<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { onClickPairDevice, isPairing, stopPairing, pairingCode } from './pairing';
import CopyButton from "@/ui-plus/CopyButton.vue";

function openZemegaTerms() {
    window.open('https://www.zemega.com/terms/')
}
</script>

<template>
    <div class="border rounded-lg p-4 border-foreground">
        <p class="text-xs text-muted-foreground">
            (you may pair this device with a single store or multiple stores)
        </p>
        <Button @click="onClickPairDevice"
                variant="secondary"
                v-if="!isPairing">
            Pair with a new store
        </Button>
        <Button @click="stopPairing"
                variant="outline"
                v-else>
            Stop pairing
        </Button>
        <br>
        <div v-if="pairingCode && isPairing"
             class="pt-8">
            one-time-pairing-code:
            <br>
            <CopyButton :content="pairingCode"
                        class="mt-2">
                <span class="text-3xl font-bold">
                    {{ pairingCode }}
                </span>
            </CopyButton>
            <br>
            <br>
            once asked to pair with a store, please enter the code above.
            <br>
            <br>
            after pairing, you may close this window. closing this window will NOT quit the app.
        </div>
    </div>
    <Button variant="link"
            class="mt-2 px-0"
            @click="openZemegaTerms">
        <!-- Zemega.com  -->
        Terms
    </Button>
</template>